import React from 'react'
import PropTypes from 'prop-types'

import { Secondary } from 'components/base/Button'
import { Button } from 'components/base'

class SaveBanner extends React.Component {
  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
  }

  render() {
    return (
      <div
        className="width-full background-shade-100 position-absolute flexbox flexbox-centered flexbox-align-center padding-vertical-medium shadow-medium zindex-large"
        style={{
          bottom: 0,
          left: 0,
        }}
      >
        <div className="flexbox">
          <Secondary
            className="margin-right-normal"
            onClick={this.props.onCancel}
          >
            Cancel
          </Secondary>
          <Button.Primary onClick={event => this.props.onSave(event)}>
            Save changes
          </Button.Primary>
        </div>
      </div>
    )
  }
}

export default SaveBanner
